"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genMonthsArray = void 0;
var genMonthsArray = function (nameLength) {
    var form = {
        long: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ],
        short: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ],
    };
    var monthsAry = form[nameLength].map(function (d) {
        return { display: d, value: d.toLowerCase() };
    });
    return monthsAry;
};
exports.genMonthsArray = genMonthsArray;
